module.exports = __webpack_public_path__ + "img/btnCard-6-m.f541045d.jpg";